import {generateCallback} from '../util/appCallback';
import nodeExtend from 'node.extend';
import invoking from '../util/invoking';
import util, {noop} from '../util/common';

const utmSource = {
    1: 'SHARE_WEIXIN',
    2: 'SHARE_WEIXINFEED',
    3: 'SHARE_WEIBO',
    6: 'SHARE_QQ'
};
const mamalogo = '//static-files.cdnmama.com/common/mama-logo.png';
const defaultShareConfig = {
    title: '妈妈网', // 分享标题，默认'妈妈网'
    desc: '妈妈网',
    link: window.location.href,
    btnText: '',
    btnIcon: '',
    imgUrl: mamalogo,
    bannerUrl: mamalogo, // 分享海报，默认妈妈网LOGO
    mediaUrl: '//static-files.cdnmama.com/act/2018/2018mothersday/bgm.mp3', // 分享音频或视频
    // 小程序相关
    miniWebPageUrl: window.location.href,
    miniId: '',
    miniPath: '/page/index',
    miniTitle: '妈妈网',
    miniDesc: '妈妈网小程序',
    miniImgUrl: mamalogo, // 比例是 5 比 4，小于 128k
    ztID: 0,
    customType: '', // 1-微信 2-朋友圈 4-新浪微博 8-qq空间, 16-QQ（比如 3 表示微信和朋友圈）
    type: 1, // 1-图文分享 2-海报分享 3-音频分享 4-视频分享 5-小程序分享
    // 自定义分享前回调勾子
    beforeShare(res, next) {
        next();
    },
    success() {
        // 成功回调
    },
    fail() {
        // 失败回调
    },
    cancel() {
        // 取消回调
    },
    complete() {
        // 完成回调
    }
};
let prevShareConfig = {};
const createShareCallBack = function (opt, methodName) {
    if ((this.UA.pregnancyhelper && this.compareVer('6.7') < 0) || (this.UA.mmq && this.compareVer('8.7') < 0)) {
        window.Mama.shareResult = function (type, status) {
            if (Number(status) === 1) {
                util.countShare(type, opt.ztID);
                opt.success({type});
            } else {
                opt.cancel({});
            }
            opt.complete({type, status});
        };
        window.shareCallBack = function () {
            util.countShare('', opt.ztID);
            opt.success({});
            opt.complete({});
        };
    } else {
        window.Mama.shareResult[methodName] = function (res) {
            if (Number(res.code) === 0 && Number(res.data.status) === 1) {
                util.countShare(res.data.type, opt.ztID);
                opt.success({
                    type: res.data.type,
                    status: res.data.status
                });
            } else {
                opt.cancel({});
            }
            opt.complete(res.data || {});
        };
    }
};
// 分享按钮配置
export function onMenuShare(option) {
    this.onMenuShareUpdate(option, false);
}
export function onMenuShareUpdate(option, isUpdate = true) {
    let opt = {};
    const tempShareConfig = nodeExtend(true, {}, defaultShareConfig);
    const hasBeforeShareCallBack = Boolean(option.beforeShare);
    // 允许为空,因为 app 不支持空字符，空实体符占位
    if (option.title === '') {
        option.title = '\u200E';
    }
    // 允许为空,因为 app 不支持空字符，空实体符占位
    if (option.desc === '') {
        option.desc = '\u200E';
    }
    // 不允许为空
    if (option.link === '') {
        option.link = defaultShareConfig.link;
    }
    // 不允许为空
    if (option.imgUrl === '') {
        option.imgUrl = defaultShareConfig.imgUrl;
    }
    if (isUpdate && Object.keys(prevShareConfig).length) {
        opt = nodeExtend(true, prevShareConfig, option);
    } else {
        opt = nodeExtend(true, tempShareConfig, option);
        prevShareConfig = opt; // 保留上一次的配置，用于局部更新配置
    }
    opt.title = opt.title.substr(0, 100);
    opt.desc = opt.desc.substr(0, 100);
    opt.link = util.formatURL(opt.link);
    opt.miniWebPageUrl = util.formatURL(opt.miniWebPageUrl);
    opt.imgUrl = util.formatURL(opt.imgUrl);
    opt.bannerUrl = util.formatURL(opt.bannerUrl);
    opt.mediaUrl = util.formatURL(opt.mediaUrl);
    opt.btnIcon = util.formatURL(opt.btnIcon);
    // 处理success不为函数的情况
    if (typeof opt.success !== 'function') {
        opt.success = noop;
    }
    createShareCallBack.call(this, opt, 'navRightButtonInfo');
    let shareConfig = {
        mshareTitle: opt.title,
        mshareDesc: opt.desc,
        mshareImage: opt.imgUrl,
        mshareUrl: opt.link,
        notEncodeShareURL: true
    };
    if (opt.ext) {
        shareConfig = nodeExtend(true, shareConfig, opt.ext);
    }
    // 自定义分享
    if (
        (opt.customType || hasBeforeShareCallBack || opt.type > 1) &&
        ((this.UA.mmq && this.compareVer('8.5') > -1) || (this.UA.pregnancyhelper && this.compareVer('6.4.5') > -1))
    ) {
        if (!opt.customType) {
            // beforeShare 存在，要配置自定义模式 customType，否则 beforeShare 不生效
            // 默认除二维码外的其它
            opt.customType = window.parseInt(110111111, 2);
        }
        /**
         * 自定义面板，需要主动触发调起落地 APP
         * @param updateOpt 需要更新的分享字段
         */
        let openAppType = 1;
        const nextHook = (updateOpt = {}) => {
            const nextHookOpt = nodeExtend(true, opt, updateOpt);
            nextHookOpt.link = util.formatURL(nextHookOpt.link);
            nextHookOpt.miniWebPageUrl = util.formatURL(nextHookOpt.miniWebPageUrl);
            nextHookOpt.imgUrl = util.formatURL(nextHookOpt.imgUrl);
            nextHookOpt.bannerUrl = util.formatURL(nextHookOpt.bannerUrl);
            nextHookOpt.mediaUrl = util.formatURL(nextHookOpt.mediaUrl);
            nextHookOpt.openAppType = openAppType;
            this.raiseNativeShare(nextHookOpt, true);
        };
        shareConfig.customType = opt.customType;
        shareConfig.customTypeCallback = generateCallback(
            {
                success: function (data) {
                    openAppType = data.type; // 缓存点击的类型
                    data.typeName = utmSource[data.type] || '__SHARECHANEL__';
                    opt.beforeShare(data, nextHook);
                }
            },
            res => {
                if (typeof res == 'string') {
                    res = JSON.parse(res);
                }
                return {
                    code: 0, // 执行 success
                    data: res.data
                };
            },
            false
        );
    }
    let btnIcon = '';
    if (!opt.btnText) {
        btnIcon = 'https://static-files.cdnmama.com/common/pt-btn-share.png';
    }
    if (this.navRightButtonInfo) {
        this.navRightButtonInfo({
            type: 4,
            text: ' ',
            icon: this.customShareBtn || opt.btnIcon || btnIcon,
            subtype: '',
            waplink: '',
            jsmethod: '',
            ext: shareConfig
        });
    }
}
// isFromOnMenuShare 是否在右上角按钮调用
export function raiseNativeShare(option, isFromOnMenuShare = false) {
    const tempShareConfig = nodeExtend(true, {}, defaultShareConfig);
    const opt = nodeExtend(true, tempShareConfig, option);

    if (
        (this.UA.ios && this.UA.pregnancyhelper && this.compareVer('6.4.5') > -1) ||
        (this.UA.ios && this.UA.mmq && this.compareVer('8.5') > -1) ||
        (this.UA.android && this.UA.mmq && this.compareVer('8.6') > -1) ||
        (this.UA.android && this.UA.pregnancyhelper && this.compareVer('6.6') > -1) ||
        (isFromOnMenuShare && this.UA.android && this.UA.mmq && this.compareVer('8.5') > -1) ||
        (isFromOnMenuShare && this.UA.android && this.UA.pregnancyhelper && this.compareVer('6.4.5') > -1)
    ) {
        createShareCallBack.call(this, opt, 'raiseNativeShare');

        // 兼容安卓孕管 <=6.4.6，图文类型缩略图被海报图覆盖
        if (~~opt.type !== 2) {
            opt.bannerUrl = '';
        }
        if (opt.type === 5 && opt.openAppType !== 1) {
            // 因为小程序只能分享给微信好友，所以点其它渠道，又定义了分享类型为小程序时，只能选强制分享图文
            opt.type = 1;
        }
        invoking({
            action: 'raiseNativeShare',
            version: '1.2.0',
            data: {
                openAppType: opt.openAppType,
                type: opt.type,
                ext: {
                    // 通用数据
                    title: opt.title,
                    desc: opt.desc,
                    imgUrl: util.formatURL(opt.imgUrl),
                    localPath: opt.localPath,
                    // 微信 qq 微博等分享
                    mshareTitle: opt.title.substr(0, 100),
                    mshareDesc: opt.desc.substr(0, 100),
                    mshareUrl: util.formatURL(opt.link),
                    mshareImage: util.formatURL(opt.imgUrl),
                    mshareBannerUrl: util.formatURL(opt.bannerUrl),
                    mshareMediaUrl: util.formatURL(opt.mediaUrl),
                    // 微信小程序分享
                    miniWebPageUrl: util.formatURL(opt.miniWebPageUrl),
                    miniId: opt.miniId,
                    miniPath: opt.miniPath,
                    miniTitle: opt.miniTitle,
                    miniDesc: opt.miniDesc,
                    miniImgUrl: util.formatURL(opt.miniImgUrl),
                    notEncodeShareURL: true,
                    // 分享到发贴的数据
                    topic: opt.topic,
                    topicId: opt.topicId,
                    postSource: opt.postSource
                }
            }
        });
    } else {
        // raiseNativeShare 的 openAppType，对应 openSharePanel 方法的 customType
        // 不支持直接调起，降级为打开面板
        const openAppTypeToCustomType = {
            1: 1,
            2: 2,
            3: 4,
            4: 8,
            6: 16
        };
        opt.customType = openAppTypeToCustomType[opt.openAppType];
        this.openSharePanel(opt);
    }
}
export function openSharePanel(option) {
    if (this.openSharePlatform) {
        const tempShareConfig = nodeExtend(true, {}, defaultShareConfig);
        const hasBeforeShareCallBack = Boolean(option.beforeShare);
        const opt = nodeExtend(true, tempShareConfig, option);
        opt.title = opt.title.substr(0, 100);
        opt.desc = opt.desc.substr(0, 100);
        opt.link = util.formatURL(opt.link);
        opt.miniWebPageUrl = util.formatURL(opt.miniWebPageUrl);
        opt.imgUrl = util.formatURL(opt.imgUrl);
        opt.bannerUrl = util.formatURL(opt.bannerUrl);
        opt.mediaUrl = util.formatURL(opt.mediaUrl);
        opt.btnIcon = util.formatURL(opt.btnIcon);
        let openAppType = 1;

        createShareCallBack.call(this, opt, 'openSharePlatform');
        // 自定义分享
        if (
            (opt.customType || hasBeforeShareCallBack || opt.type > 1) &&
            ((this.UA.ios && this.UA.pregnancyhelper && this.compareVer('6.4.5') > -1) ||
                (this.UA.ios && this.UA.mmq && this.compareVer('8.5') > -1) ||
                (this.UA.android && this.UA.mmq && this.compareVer('8.6') > -1) ||
                (this.UA.android && this.UA.pregnancyhelper && this.compareVer('6.6') > -1))
        ) {
            if (!opt.customType) {
                // beforeShare 存在，要配置自定义模式 customType，否则 beforeShare 不生效
                // 所以判断 customType，没有的话，默认赋值一个相对比较高的数（全选的意思）
                opt.customType = window.parseInt(110111111, 2);
            }
            /**
             * 自定义面板，需要主动触发调起落地 APP
             * @param updateOpt 需要更新的分享字段
             */
            const nextHook = (updateOpt = {}) => {
                const nextHookOpt = nodeExtend(true, opt, updateOpt);
                nextHookOpt.link = util.formatURL(nextHookOpt.link);
                nextHookOpt.miniWebPageUrl = util.formatURL(nextHookOpt.miniWebPageUrl);
                nextHookOpt.imgUrl = util.formatURL(nextHookOpt.imgUrl);
                nextHookOpt.bannerUrl = util.formatURL(nextHookOpt.bannerUrl);
                nextHookOpt.mediaUrl = util.formatURL(nextHookOpt.mediaUrl);
                nextHookOpt.openAppType = openAppType;
                this.raiseNativeShare(nextHookOpt);
            };
            opt.customTypeCallback = generateCallback(
                {
                    success(data) {
                        openAppType = data.type;
                        data.typeName = utmSource[data.type] || '__SHARECHANEL__';
                        opt.beforeShare(data, nextHook);
                    }
                },
                res => {
                    if (typeof res === 'string') {
                        res = JSON.parse(res);
                    }
                    return {
                        code: 0, // 执行 success
                        data: res.data
                    };
                },
                false
            );
        }
        const shareConfig = nodeExtend(true, opt, {
            mshareTitle: opt.title,
            mshareDesc: opt.desc,
            mshareImage: opt.imgUrl,
            mshareUrl: opt.link,
            notEncodeShareURL: true
        });
        // 处理孕管安卓带错误二维码问题
        if (
            this.UA.android &&
            this.UA.pregnancyhelper &&
            this.compareVer('6.4.0') > -1 &&
            Number(this.compareVer('6.5.0')) === -1
        ) {
            createShareCallBack.call(this, opt, 'openNativeShare');
            this.openNativeShare({
                ext: shareConfig
            });
        } else {
            // 不能传用不上的 type，会导致 ios 走了右上角配置冲突
            const tempConfig = nodeExtend(true, {}, shareConfig);
            if (tempConfig.type === 5 && tempConfig.openAppType !== 1) {
                // 因为小程序只能分享给微信好友，所以点其它渠道，又定义了分享类型为小程序时，只能选强制分享图文
                tempConfig.type = 1;
            }
            this.openSharePlatform(nodeExtend(true, tempConfig, {type: ''}));
        }
    }
}

export default {
    onMenuShare,
    onMenuShareUpdate,
    raiseNativeShare,
    openSharePanel
};
